import { _APP_CONFIG } from "../../core/config/AppConfig";
import { ILicenciaConfigOrganizacion, ILicenciaPlantilla } from "../../core/types/LicenciaTypes";
import { DataDRequest } from "../DRequest";
import { DataUtil } from "../util/Util";


export function _SvLicenciaObtenerConfiguracionOrganizacion(idOrganizacion: number): Promise<DataDRequest.IRequestResponseA<ILicenciaConfigOrganizacion>> {
    const url = `${_APP_CONFIG.URL_RSTV2}licencia/ObtenerConfiguracionOrgV2`;
    const params = {
        Id: idOrganizacion
    }
    return DataDRequest._Request5<ILicenciaConfigOrganizacion>(url, "GET", params);
}

export function _SvLicenciaObtenerPlantillas(): Promise<DataDRequest.IRequestResponseA<ILicenciaPlantilla[]>> {
    const url = `${_APP_CONFIG.URL_RSTV2}licencia/ObtenerPlantillas`;
    return DataDRequest._Request5<ILicenciaPlantilla[]>(url, "GET", {})
        .then(res => (
            res.Datos.forEach(d => (d.ModulosExtra = (d.ModulosExtra as unknown as string).split(",").map(d => +d) || [])),
            res
        ));
}

export function _SvLicenciaActivarOrganizacion(idLicenciaPlantilla: number | null): Promise<DataDRequest.IRequestResponseA> {
    const url = `${_APP_CONFIG.URL_RSTV2}licencia/ActivarOrganizacion`;
    const params = {
        "Id": DataUtil._Usuario.IdOrganizacion,
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "IdLicenciaPlantilla": idLicenciaPlantilla || 0
    };
    return DataDRequest._Request5(url, "POST", params);
}
